const timetable = [
  {
    timeslot: "13:00 Uhr",
    title: "Begrüßung",
    participants: "Moderation: Prof. Kathleen Kunert, Prof. Klaus Rohrschneider, Prof. Norbert Schrage"
  },
  {
    timeslot: "13:10 Uhr – 13:45 Uhr",
    title: "Wo stehen wir in der augenärztlichen Versorgung im Akutbereich, in der Rehabilitation und beruflichen Perspektive?",
    participants: "2 Impulse: Dr. Bettina von Livonius, Klinikum der Universität München; Christiane Möller, Deutscher Blinden- und Sehbehindertenverband (DBSV), Berlin"
  },
  {
    timeslot: "13:45 Uhr – 14:10 Uhr",
    title: "Rehabilitationsbedarf aus epidemiologischen Daten",
    participants: "Prof. Alexander Schuster, Universitätsmedizin Mainz"
  },
  {
    timeslot: "14:10 Uhr – 14:35 Uhr",
    title: "Wie können die Deutsche Rentenversicherung (DRV) und die Bundesarbeitsgemeinschaft für Rehabilitation (BAR) konkret unterstützen a) Beratung der Patienten und b) Anträge",
    participants: "Dr. Teresia Widera, BAR Frankfurt; Dr. Beate Blichmann, DRV Berlin"
  },
  {
    timeslot: "14:35 Uhr – 15:00 Uhr",
    title: "Chancen von Telemedizin in einer angespannten Versorgungssituation",
    participants: "Dr. Claus Gruber, Mirantus GmbH, Berlin; Dr. Lars Choritz, Medizinische Fakultät, Universitätsklinikum Magdeburg"
  },
  {
    timeslot: "15:00 Uhr – 15:30 Uhr",
    title: "Diagnose Tumor im Auge – und jetzt? Von der Akutbehandlung bis zur Teilhabe",
    participants: "Prof. Vinodh Kakkassery, Klinikum Chemnitz gGmbH; Prof. Kathleen Kunert, Henneberg REKA-Klinik Masserberg"
  },
  {
    timeslot: "15:30 Uhr – 15:55 Uhr",
    title: "Der Weg zum Hilfsmittel – was kann verordnet werden?",
    participants: "Marco Brechmann, F.H. Papenmeier; Thomas Wahr, Reinecker Vision GmbH"
  },
  {
    timeslot: "15:55 Uhr – 16:25 Uhr",
    title: "Kaffeepause",
    participants: ""
  },
  {
    timeslot: "16:25 Uhr – 17:10 Uhr",
    title: "Wohnortnahe Rehabilitationsangebote durch O&M und LPF",
    participants: "Prof. Sabine Lauber-Pohle, Uni Marburg; Diskussion: Prof. Sabine Lauber-Pohle; Christiane Möller, DBSV; Peter Brill, Bundesverband der Rehabilitationslehrer/-innen für Blinde und Sehbehinderte e. V."
  },
  {
    timeslot: "17:10 Uhr – 17:35 Uhr",
    title: "Einbeziehung der Optometrie in die ophthalmologische Versorgung",
    participants: "Prof. Tobias Brockmann (online), Universitätsmedizin Rostock"
  },
  {
    timeslot: "17:35 Uhr – 18:00 Uhr",
    title: "Tel-O-Rena: Telematische ophthalmologische Reha-Nachsorge",
    participants: "Oliver Kolbe, Henneberg REKA-Klinik Masserberg"
  },
  {
    timeslot: "18:00 Uhr – 18:30 Uhr",
    title: "Zusammenfassung, Diskussion",
    participants: ""
  }
];

export const TimeTable = () => {
  return (
    <div className={"container mt-5 border-top pt-3 border-t-gray-400 w-full"}>
      <h3 className={"text-center "}>Agenda</h3>
      <div>
        {timetable.map((item, index) => (
          <div key={index} className={"mb-4"}>
            <p className={"fw-bold mb-0"}>{item.timeslot}</p>
            <p className={"mb-1"}>{item.title}</p>
            <p className={"fst-italic small"}>{item.participants}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
